module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Logs', {
    attrs: {
      "showForm": _vm.showLogs,
      "formData": _vm.formData
    }
  }), _vm._v(" "), _c('Agendamento', {
    attrs: {
      "showForm": _vm.showAgendamento
    }
  }), _vm._v(" "), _c('div', [(!_vm.avulso) ? _c('div', {
    staticClass: "esocial-toolbar"
  }, [(!_vm.lote) ? _c('div', {
    staticClass: "esocial-tabs"
  }, _vm._l((_vm.config.list.esocial_tabela), function(tabela) {
    return _c('div', {
      key: tabela.id,
      staticClass: "esocial-tabs__item",
      class: {
        'is-active': _vm.formData.layout == tabela.codigo
      },
      on: {
        "click": function($event) {
          _vm.formData.layout = tabela.codigo
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-code-o"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(tabela.codigo))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "esocial-search"
  }, [_c('div', {
    staticClass: "esocial-search__group"
  }, [_c('div', {
    staticClass: "esocial-search__input"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.search),
      expression: "formData.search"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.lote ?
        'Pesquisar por Empresa, Funcionário...' :
        'Pesquisar por Consulta, Recibo, Lote, Funcionário, Empresa...'
    },
    domProps: {
      "value": (_vm.formData.search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getEsocial(_vm.formData.search)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--attached",
    on: {
      "click": function($event) {
        return _vm.getEsocial(_vm.formData.search)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n          ")])]), _vm._v(" "), (!_vm.lote) ? _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.showFilterModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n          "), (_vm.filterBadge > 0) ? _c('span', {
    staticClass: "esocial-search__badge"
  }, [_vm._v(_vm._s(_vm.filterBadge))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn",
    attrs: {
      "title": "Rotinas Automáticas"
    },
    on: {
      "click": function($event) {
        _vm.showAgendamento = !_vm.showAgendamento
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.avulso) ? _c('ed-table', {
    attrs: {
      "onSearch": _vm.getEsocial,
      "onRegister": _vm.onRegister,
      "onEdit": _vm.onEditXml,
      "onClear": _vm.onClear,
      "onFilter": _vm.getEsocial,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "disableInputSearch": false,
      "registerName": "Inserir novo XML"
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('Filters', {
    attrs: {
      "parent": this
    }
  })], 1)]) : _c('esocial-tabela', {
    attrs: {
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "search": _vm.formData.search,
      "onSearch": _vm.getEsocial,
      "onBulkGerarXml": _vm.lote ? null : _vm.onBulkGerarXml,
      "disableCheckAll": !!_vm.lote
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showFilterModal) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showFilterModal = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Filtrar Resultado")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [(_vm.showFilterModal) ? _c('Filters', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn",
    on: {
      "click": function($event) {
        _vm.onClear();
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Limpar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": function($event) {
        _vm.getEsocial(_vm.formData.search);
        _vm.showFilterModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n            ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.avulso) ? _c('s0000', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2210'
  ) ? _c('s2210', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2220'
  ) ? _c('s2220', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2240'
  ) ? _c('s2240', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-3000'
  ) ? _c('s3000', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModalUid) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModalUid = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Atualizar dados do evento")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModalUid = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": {
        novoUid: _vm.novoUid
      }
    }
  }, [_c('ed-alert', {
    staticClass: "px-3 mt-2",
    attrs: {
      "title": "Atenção",
      "type": "warning"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                Se o campo recibo for preenchido ou atualizado, o sistema alterará o status para \"Processado com sucesso\". Caso fique vazio, ele não altera o status atual do evento. A edição manual do recibo fica registrada (usuário e data).\n              ")])]), _vm._v(" "), (_vm.reciboManualInfo) ? _c('ed-alert', {
    staticClass: "px-3 mt-2",
    attrs: {
      "title": "Já editado manualmente",
      "type": "info"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n                O recibo deste evento já foi alterado manualmente por "), _c('b', [_vm._v(_vm._s(_vm.reciboManualInfo.usuario))]), _vm._v(" em " + _vm._s(_vm.reciboManualInfo.data) + ".\n              ")])]) : _vm._e(), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Atualizar UID",
      "name": "novoUid",
      "required": ""
    },
    model: {
      value: (_vm.novoUid),
      callback: function($$v) {
        _vm.novoUid = $$v
      },
      expression: "novoUid"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Adicionar/atualizar recibo",
      "name": "novoRecibo",
      "required": ""
    },
    model: {
      value: (_vm.novoRecibo),
      callback: function($$v) {
        _vm.novoRecibo = $$v
      },
      expression: "novoRecibo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    on: {
      "click": _vm.saveUid
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Salvar\n          ")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.showModalDownloadXML) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showModalDownloadXML = false
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--xml"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Arquivo XML " + _vm._s(_vm.xmlPreview.filename))]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    on: {
      "click": function($event) {
        _vm.showModalDownloadXML = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body esocial-modal__body--xml"
  }, [_c('div', {
    staticClass: "esocial-tabs esocial-tabs--xml"
  }, [_c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.xmlViewMode == 'arvore'
    },
    on: {
      "click": function($event) {
        _vm.xmlViewMode = 'arvore'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-code"
  }), _vm._v(" "), _c('span', [_vm._v("Árvore")])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-tabs__item",
    class: {
      'is-active': _vm.xmlViewMode == 'tabela'
    },
    on: {
      "click": function($event) {
        _vm.xmlViewMode = 'tabela'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', [_vm._v("Tabela")])])]), _vm._v(" "), (_vm.xmlViewMode == 'arvore') ? _c('div', {
    staticClass: "xml-preview"
  }, [(_vm.xmlPreview.content) ? _c('XmlViewer', {
    attrs: {
      "xml": _vm.xmlPreview.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.xmlViewMode == 'tabela') ? _c('div', {
    staticClass: "xml-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Campo")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.xmlPreview.campos), function(campo, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "xml-table__campo"
    }, [_vm._v(_vm._s(campo.caminho))]), _vm._v(" "), _c('td', {
      staticClass: "xml-table__valor"
    }, [_vm._v(_vm._s(campo.valor))])])
  }), 0)]), _vm._v(" "), (!_vm.xmlPreview.campos.length) ? _c('div', {
    staticClass: "xml-table__empty"
  }, [_vm._v("Nenhum campo encontrado no XML.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-modal__btn-download",
    on: {
      "click": _vm.downloadXMLPreview
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Baixar arquivo XML\n          ")])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33efc7d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/index.vue
// module id = 1472
// module chunks = 45